import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import * as DTOS from "../../../../FeralScan.dtos";
import { IAppState } from '../../../../app';
import * as DashboardActionCreators from "../../../../actions/dashboard.actions";
import * as SurveyActionCreators from "../../../../actions/survey.actions";
import * as MapActionCreators from "../../../../actions/map.actions";
import * as DataActionCreators from "../../../../actions/data.actions";
import { actions as FormActions } from 'react-redux-form'
import SurveyForm, { SurveyFormPropsAndActions } from '../../../../containers/survey.container';
import { Redirect, withRouter } from 'react-router';
import { History } from 'history'
import Loader from 'react-loaders';

interface IPagePlotSurveyProps {
    history?: History;
    //plot: DTOS.Plot;
    plots: DTOS.Plot[];
    eventTypeId: number;
    layers: any;
    mapMarkerComponent: any;
    openMarkers: any;
    referenceData: any;
    speciesId: number;
    survey: DTOS.Survey;
    surveyLoading: boolean;
    surveySaving: boolean;
    uploadingFile: boolean;
    userPlots: DTOS.Plot[];

    preamble: (props: PagePlotSurveyProps) => any;

    changeEventType?: typeof SurveyActionCreators.changeEventTypeRequest;
    changeSpecies?: typeof SurveyActionCreators.changeSpeciesRequest;
    clearSurvey?: typeof SurveyActionCreators.clearSurveyRequest;
    error?: typeof DashboardActionCreators.errorRequest;
    getEventQuestions?: typeof SurveyActionCreators.getEventQuestionsRequest;
    setQuestionValue?: typeof SurveyActionCreators.setQuestionValueRequest;
    submitSurvey?: typeof SurveyActionCreators.saveEventRequest;
    toggleMarkerPopup?: typeof MapActionCreators.toggleMarkerPopupRequest;
    uploadFiles?: typeof SurveyActionCreators.uploadFilesRequest;
    resetForm?: typeof FormActions.reset;

    getSinglePlot: typeof DataActionCreators.getSinglePlotRequest;

    onSubmitSurveyRoute: (props: PagePlotSurveyProps) => string;
}

interface IPagePlotSurveyRouteParams {
    plotId: string;
}

interface IPagePlotSurveyQueryParams {
}

interface IPagePlotSurveyListMapped {
}

type PagePlotSurveyProps = IBasePageProps<IPagePlotSurveyRouteParams, IPagePlotSurveyQueryParams> & IPagePlotSurveyListMapped & IPagePlotSurveyProps;

class PagePlotSurvey extends React.Component<PagePlotSurveyProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        if (this.props.routeParams.plotId) {
            this.props.getSinglePlot(Number(this.props.routeParams.plotId));
        }
    }

    componentDidUpdate(prevProps: PagePlotSurveyProps) {

        if (!this.props.surveySaving && prevProps.surveySaving) {
            this.props.history.push(this.props.onSubmitSurveyRoute(this.props));
        }
    }

    render() {
        const plot = this.props.plots ? this.props.plots.find(p => p.id === Number(this.props.routeParams.plotId)) : undefined;

        return (
            this.props.surveySaving ?
                <div className="position-absolute"
                    style={{ bottom: '50%', left: '42%' }}>
                    <Loader type="ball-scale-multiple" active />
                    <div className="ml-4 small">please wait, submitting</div>
                </div>
                :
                this.props.referenceData && !this.props.referenceData.loading && plot ?
                    <div className="m-3">
                        <h2>Add data to {this.props.plots ? plot.name : 'unknown'}</h2>
                        {this.props.preamble ? this.props.preamble(this.props) : undefined}
                        <SurveyForm
                            classification={'Platypus'}
                            eventTypeId={this.props.eventTypeId}
                            loading={this.props.surveyLoading}
                            referenceData={this.props.referenceData}
                            mapMarkerComponent={this.props.mapMarkerComponent}
                            speciesId={this.props.speciesId}
                            survey={this.props.survey}
                            type={'Platypus'}
                            userPlots={this.props.userPlots}
                            changeEventType={this.props.changeEventType}
                            setQuestionValue={this.props.setQuestionValue}
                            changeSpecies={this.props.changeSpecies}
                            changeTab={undefined}
                            clearSurvey={this.props.clearSurvey}
                            error={this.props.error}
                            resetForm={this.props.resetForm}
                            getEventQuestions={this.props.getEventQuestions}
                            submitSurvey={this.props.submitSurvey}
                            uploadFiles={this.props.uploadFiles}
                            uploadingFile={this.props.uploadingFile}
                            selectedPlotId={Number(this.props.routeParams.plotId)}
                        //onSubmitSurveyRoute={props => { return this.props.onSubmitSurveyRoute(props) }}
                        />
                    </div> : <div className="position-absolute"
                        style={{ bottom: '50%', left: '42%' }}>
                        <Loader type="ball-scale-multiple" active />
                        <div className="ml-4 small">please wait, loading page</div>
                    </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PagePlotSurveyProps) => {

    return {
        //plot: state.data.plot,
        plots: state.data.plots,
        userPlots: state.data.userPlots,

        layers: state.data.layers,
        openMarkers: state.map.openMarkers,
        referenceData: state.referenceData,

        eventTypeId: state.surveyState.eventTypeId,
        speciesId: state.surveyState.speciesId,
        survey: state.surveyState.survey,
        surveyLoading: state.surveyState.loading,
        surveySaving: state.surveyState.saving,
        uploadingFile: state.surveyState.uploadingFile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        changeEventType: SurveyActionCreators.changeEventTypeRequest,
        changeSpecies: SurveyActionCreators.changeSpeciesRequest,
        clearSurvey: SurveyActionCreators.clearSurveyRequest,
        error: DashboardActionCreators.errorRequest,
        getEventQuestions: SurveyActionCreators.getEventQuestionsRequest,
        getSinglePlot: DataActionCreators.getSinglePlotRequest,
        setQuestionValue: SurveyActionCreators.setQuestionValueRequest,
        submitSurvey: SurveyActionCreators.saveEventRequest,
        toggleMarkerPopup: MapActionCreators.toggleMarkerPopupRequest,
        uploadFiles: SurveyActionCreators.uploadFilesRequest,
        resetForm: FormActions.reset,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PagePlotSurvey));